import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    error: false, // Track if last query failed
    previousFilters: null, // Store filters to compare on next open
};

// Async thunk to search graphic alerts by type
export const searchGraphicAlertsByType = createAsyncThunk(
    'accounts/systemAlertGraphicView/search',
    async (payload, { rejectWithValue }) => {
        try {
            const { companyId, unitId, limit, range } = payload;

            const QUERY = `
                query getGraphicAlertsByType (
                    $companyId: Int!
                    $unitId: Int
                    $limit: Int
                    $range: AWSDateTimeRange
                ) {
                    result: getGraphicAlertsByType (
                        companyId: $companyId
                        unitId: $unitId
                        limit: $limit
                        range: $range
                    )  {
                        AlertName
                        AlertType
                        AlertSeverity
                        Quantity
                    }
                }
            `;

            const variables = {
                companyId,
                unitId,
                limit: limit || null,
                range: range || null
            };

            const data = await clientQuery(
                QUERY,
                variables,
                endpoints.GRAPHQL_GENERAL,
            );

            return data?.result || [];

        } catch (exc) {
            ExceptionManager(exc, 'Modules/accounts/.components/systemAlertLogsTab/.components/graphicView/redux/slice', 'searchGraphicAlertsByType');
            return rejectWithValue(exc.message || 'Error fetching graphic alerts');
        }
    }
);

const systemAlertGraphicViewSlice = createSlice({
    name: 'accounts/systemAlertGraphicView',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
        },
        systemAlertGraphicViewOpenModal(state, action) {
            state.openModal = action.payload;
        },
        systemAlertGraphicViewSaveFilters(state, action) {
            state.previousFilters = action.payload;
        },
        systemAlertGraphicViewClearResult(state, action) {
            // Clear result before new search, optionally keeping some state
            if (action.payload) {
                return { ...state, ...action.payload };
            }
            state.result = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchGraphicAlertsByType.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchGraphicAlertsByType.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.error = false;
            })
            .addCase(searchGraphicAlertsByType.rejected, (state) => {
                state.loading = false;
                state.result = [];
                state.error = true; // Mark that query failed
            });
    },
});

const { actions, reducer } = systemAlertGraphicViewSlice;

export const {
    reset,
    systemAlertGraphicViewOpenModal,
    systemAlertGraphicViewSaveFilters,
    systemAlertGraphicViewClearResult
} = actions;

export default reducer;
